import { useEffect, useState } from 'react';

import axios from 'axios';

type ParamsType = {
  url: string | undefined | null;
  isProtectedUrl?: boolean;
};

export const useAuthorizedFile = (params: ParamsType) => {
  const { url, isProtectedUrl = false } = params;

  const [blobUrl, setBlobUrl] = useState<string>('');

  const getAccess = async (url: string) => {
    return await axios
      .get(url, {
        responseType: 'blob',
      })
      .then((response) => {
        return URL.createObjectURL(response as unknown as Blob);
      })
      .catch(() => {
        setBlobUrl('');
      });
  };

  useEffect(() => {
    if (!url || !isProtectedUrl) return;
    setBlobUrl('');
    getAccess(url).then((confirmBlob) => {
      if (confirmBlob) setBlobUrl(confirmBlob);
      else setBlobUrl('');
    });

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, isProtectedUrl]);

  if (!isProtectedUrl)
    return {
      blobUrl: url,
    };

  return {
    blobUrl,
  };
};
